import React, { useState } from 'react'
import {
	Button,
	Checkbox,
	Form,
	Input,
	InputNumber,
	message,
	Select,
} from 'antd'
// eslint-disable-next-line import/no-extraneous-dependencies
import { ValidateErrorEntity } from 'rc-field-form/lib/interface'
import handleFormError from 'utils/handleFormError'
import makeWalletTransaction, {
	WalletTransactionBody,
} from 'api/clients/makeWalletTransaction'

const { Item } = Form
const { Option } = Select

interface PropTypes {
	clientId: string
	onSuccess: Function
}

const AddDeductMoneyForm: React.FC<PropTypes> = ({ clientId, onSuccess }) => {
	const [loading, setLoading] = useState<boolean>(false)

	const [form] = Form.useForm<WalletTransactionBody>()

	const transactionType = Form.useWatch('transactionType', form)

	const onFinish = async (values: WalletTransactionBody) => {
		try {
			setLoading(true)
			await makeWalletTransaction(clientId, values)
			setLoading(false)
			message.success('Transaction Success.')
			onSuccess(true)
		} catch (error: any) {
			setLoading(false)
			onSuccess(false)
		}
	}

	const onFinishFailed = (errorInfo: ValidateErrorEntity) => {
		handleFormError(errorInfo)
	}

	return (
		<Form
			form={form}
			name='addDeductMoneyForm'
			labelCol={{ span: 20 }}
			wrapperCol={{ span: 20 }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
			autoComplete='off'
			layout='vertical'
			initialValues={{
				amount: '',
				transactionType: '',
				remarks: '',
				taxation: false,
			}}
		>
			<Item
				label='Amount'
				name='amount'
				rules={[{ required: true, message: 'Please enter amount!' }]}
			>
				<InputNumber style={{ width: '100%' }} min={1} />
			</Item>
			<Item
				label='Transaction Type'
				name='transactionType'
				rules={[{ required: true, message: 'Please enter transaction type!' }]}
			>
				<Select placeholder='Select'>
					<Option value='CREDIT'>CREDIT</Option>
					<Option value='DEBIT'>DEBIT</Option>
				</Select>
			</Item>
			<Item
				label='Remarks'
				name='remarks'
				rules={[{ required: true, message: 'Please enter remarks!' }]}
			>
				<Input />
			</Item>
			<Item
				name='taxation'
				valuePropName='checked'
				hidden={transactionType !== 'DEBIT'}
			>
				<Checkbox>Deduct Tax (Billable)</Checkbox>
			</Item>
			<Item>
				<Button type='primary' htmlType='submit' loading={loading}>
					Submit
				</Button>
			</Item>
		</Form>
	)
}

export default AddDeductMoneyForm
